import React, { useState, useEffect, useCallback } from 'react';

import { LANGUAGES, LANGUAGE_FLAGS } from 'constants/languages.constants';
import { LanguageCode } from 'enums';
import { useLanguage } from 'hooks';

const LANGUAGE_SELECTOR_ID = 'language-selector';

const getFlagSuffix = (language: string) =>
  LANGUAGE_FLAGS[language] || language;

export const LanguageSelector: React.FC = () => {
  const { language, changeLanguage } = useLanguage();
  const [isLangSelectorOpen, setIsLangSelectorOpen] = useState(false);

  useEffect(() => {
    const onWindowClick = (event: any) => {
      const target = event.target.closest('button');
      if (target && target.id === LANGUAGE_SELECTOR_ID) {
        return;
      }
      setIsLangSelectorOpen(false);
    };
    window.addEventListener('click', onWindowClick);

    return () => {
      window.removeEventListener('click', onWindowClick);
    };
  }, []);

  const onToggleLanguageSelector = useCallback(() => {
    setIsLangSelectorOpen(!isLangSelectorOpen);
  }, [isLangSelectorOpen]);

  const onSelectLanguage = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      changeLanguage(event.currentTarget.id as LanguageCode);
    },
    [changeLanguage],
  );

  return (
    <div className="tw-relative tw-flex tw-items-center tw-h-full tw-px-1">
      <button
        id={LANGUAGE_SELECTOR_ID}
        onClick={onToggleLanguageSelector}
        className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full focus:tw-bg-component hover:tw-bg-component hover:tw-cursor-pointer"
      >
        <span className={`fi fi-${getFlagSuffix(language)}`} />
      </button>
      {isLangSelectorOpen && (
        <div className="tw-absolute tw-flex tw-flex-col tw-top-full tw-right-0 tw-w-auto tw-h-auto tw-max-h-64 tw-overflow-y-auto tw-p-1 tw-bg-payment-layout tw-rounded-lg tw-z-10">
          {LANGUAGES.map(({ code }) => (
            <button
              onClick={onSelectLanguage}
              className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full hover:tw-bg-component  hover:tw-cursor-pointer"
              id={code}
              key={code}
            >
              <span className={`fi fi-${getFlagSuffix(code)}`} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
